
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import { Options, Vue } from "vue-class-component"; //基本需要\
import { ElMessage } from "element-plus";
import {
  dispatchGetNewReportList,
  dispatchGetReportDetail,
  dispatchGetSkinReport,
  dispatchUploadReportImage,
  dispatchDeleteReport,
} from "@/store/performance/actions";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  readNewReportList,
  readNewReport,
  readSkinReport,
} from "@/store/performance/getters"; //引入仓库接口
import { store } from "@/store"; //引入仓库
// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class TestReportSkin extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  public resBase64: any[] = [];
  //报告名称
  public loading = false; //加载
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public edit = false;
  public async mounted() {
    const project = Number(this.$route.query.project);
    // this.formMail.title = (readNewReportList(store) as any[]).filter(
    //   (item: any) => item.id === this.report_id
    // )[0].report_name;
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 5,
    });

    if (this.$route.query.report_id) {
      this.report_id = Number(this.$route.query.report_id);
      this.formMail.title = (readNewReportList(store) as any[]).filter(
        (item: any) => item.id === this.report_id
      )[0].report_name;
    } else {
      this.report_id = this.nameList[0] ? this.nameList[0]?.id : 0;
    }

    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    await dispatchGetReportDetail(store, {
      project: project,
      id: this.report_id,
    });
    if (this.report_id) {
      await dispatchGetSkinReport(store, {
        project: this.localProject,
        report_id: this.report_id,
      });
    }

    await this.addressee;
    await this.getSkinReport();

    // if (this.$route.query.report_id) {
    //   if (this.$route.query.project) {
    //     const project = Number(this.$route.query.project);
    //     await dispatchGetNewReportList(store, { project: this.localProject });
    //      await dispatchGetPerfReport(store, {
    //       project: project,
    //       report_id: Number(this.$route.query.report_id),
    //     });
    //   }
    // } else {
    //   await dispatchGetNewReportList(store, { project: this.localProject });
    //   (this.name_search as any) = readNewReportList(store)[0].id;
    //   this.$router.push({
    //     query: { ...this.$route.query, report_id: this.name_search },
    //   });
    //   this.formMail.title = (readNewReportList(store) as any[]).filter(
    //     (item: any) => item.id === this.name_search
    //   )[0].report_name;
    // }
  }
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }
  //报告名称
  public report_id = 0;
  // 核心数据类型
  public get_skin_data = {
    model_list: {},
    new_version: "",
    old_version: "",
    project: {
      icon: "",
      project_name: "",
    },
    base: {
      creator: "",
      date: "",
      skin_num: 0,
      version: "",
    },
    device_list: [],
    device_type: "安卓",
    rule_settings: {
      increase_good: [],
      abs_risk_rule: {},
    },
  };
  //获取报告名称的列表
  public get nameList() {
    let name_list: any[] = [];
    name_list = readNewReportList(store);
    return name_list;
  }
  public riskLv = "";
  public get_color(item: any, value: any) {
    if (item == "var_fps" && value > 20) {
      return "red";
    }
    if ((item == 'big_jank' || item == 'jank') && value != 0) {
      return "red";
    }
    if (item == 'avg_fps' && value < 25) {
      return "red";
    }

    if (
      (this.get_skin_data.rule_settings.increase_good as any).indexOf(item) !=
        -1 &&
      this.get_skin_data.rule_settings.abs_risk_rule[item]
    ) {
      if (
        value < Number(this.get_skin_data.rule_settings.abs_risk_rule[item])
      ) {
        return "red";
      }
    } else if (
      (this.get_skin_data.rule_settings.increase_good as any).indexOf(item) ==
        -1 &&
      this.get_skin_data.rule_settings.abs_risk_rule[item]
    ) {
      if (
        value > Number(this.get_skin_data.rule_settings.abs_risk_rule[item])
      ) {
        return "red";
      } else {
        return "#212529";
      }
    }
  }
  // 报告名称切换时
  public async change_name_search() {
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 5,
    });
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0].report_name;
    await dispatchGetSkinReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await this.getSkinReport();
  }
  // 发送报告
  public save_report(is_auto?: boolean) {
    let upload_data: any;
    if (typeof is_auto === "boolean") {
      upload_data = {
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.report_id),
        file_list: this.resBase64,
        is_auto: is_auto,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        report_type: 5,
        send: this.formMail.Sender,
      };
    } else {
      upload_data = {
        // project: Number(this.$route.query.project),
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.report_id),
        file_list: this.resBase64,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        report_type: 5,
        send: this.formMail.Sender,
      };
    }

    dispatchUploadReportImage(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }
  // 解析邮件收件人
  public get addressee() {
    let addressee = JSON.parse(readNewReport(store).settings).report_settings
      .notify.email.receiver_str;
    this.formMail.addressee = addressee;

    return addressee;
  }
  // 获取报告数据
  public getSkinReport() {
    this.get_skin_data = readSkinReport(store);
    this.get_skin_data.base.date = dateConversion(
      readSkinReport(store).base.date
    );
    let riskLvList = [];
    let riskLvList1: any = [];
    for (let i in this.get_skin_data.model_list) {
      for (let k in this.get_skin_data.model_list[i].data) {
        riskLvList.push(this.get_skin_data.model_list[i].data[k]);
      }
    }
    riskLvList.forEach((v: any) => {
      v.forEach(function (k: any) {
        riskLvList1.push(k.var_fps);
      });
    });
    if (riskLvList1.some((v: any) => v > 20)) {
      this.riskLv = "高风险";
    } else {
      this.riskLv = "低风险";
    }
  }
  public sendOut() {
    this.edit = !this.edit;
  }
  // 点击删除
  public async handleDelete() {
    this.loading = true;

    await dispatchDeleteReport(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
      page: 1,
      size: 1,
      report_name: "",
      new_version: "",
      old_version: "",
      risk: "",
      creator: "",
    });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 5,
    });
    this.report_id = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });

    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.report_id),
    });
    //调用获取性能报告接口
    await dispatchGetSkinReport(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
    });

    //启用生成报告的接口

    await this.getSkinReport();

    // this.selected_scene =
    //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];

    // 从浏览器触发发送报告
    if ("screenshot" in this.$route.query) {
      this.save_report();
    }

    // await this.addressee; //解析邮件收件人

    this.loading = false;
  }
  public get get_pipeline() {
    if (this.get_skin_data.device_type === "安卓、iOS") {
      return "【Android】Trunk性能包构建，【iOS】Trunk性能包构建";
    } else if (this.get_skin_data.device_type === "安卓") {
      return "【Android】Trunk性能包构建";
    } else {
      return "【iOS】Trunk性能包构建";
    }
  }
  public get gameList() {
    const list = [
      "英雄",
      "皮肤名",

      "帧率均值",
      "帧率方差",
      "卡顿率",
      "Jank",
      "BigJank",
      "FPS<10(%)",
      "FPS>18(%)",
      "FPS>25(%)",
      "CPU占用均值(%)",
      "CPU<60(%)",
      "CPU<80(%)",
      "PSS峰值(MB)",
    ];
    return list;
  }
}
